"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _DynoElapsedTimeInput = _interopRequireDefault(require("./DynoElapsedTimeInput"));

var _UICheckbox = _interopRequireDefault(require("UIComponents/input/UICheckbox"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _DynoTypes = _interopRequireDefault(require("lead-flows-ui/constants/DynoTypes"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _SimpleWrapper = _interopRequireDefault(require("lead-flows-ui/components/common/SimpleWrapper"));

var _default = _react.default.createClass({
  displayName: "DynoTriggers",
  propTypes: {
    handleUpdateTriggers: _react.default.PropTypes.func.isRequired,
    type: _react.default.PropTypes.string.isRequired,
    error: _react.default.PropTypes.node,
    validationMessage: _react.default.PropTypes.string,
    displayOnScroll: _react.default.PropTypes.bool.isRequired,
    displayOnExitIntent: _react.default.PropTypes.bool.isRequired,
    displayOnTimedDelay: _react.default.PropTypes.number.isRequired
  },
  langKey: function langKey(suffix) {
    return "leadFlowEditor.leadFlowOptionsEditor.triggers." + suffix;
  },
  renderRecommended: function renderRecommended(show) {
    if (show) {
      return _react.default.createElement(_Small.default, {
        use: "help",
        className: "m-left-2"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('recommendedForThisFlow')
      }));
    }

    return null;
  },
  renderScrollTriggerContent: function renderScrollTriggerContent(type, displayOnScroll, updateTriggers) {
    return _react.default.createElement("div", null, _react.default.createElement(_UICheckbox.default, {
      defaultChecked: displayOnScroll,
      onChange: function onChange(_ref) {
        var checked = _ref.target.checked;
        return updateTriggers({
          displayOnScroll: checked
        });
      }
    }, _react.default.createElement(_FormattedMessage.default, {
      message: this.langKey('onScroll')
    }), this.renderRecommended(type === _DynoTypes.default.BOTTOM_LEFT || type === _DynoTypes.default.BOTTOM_RIGHT)));
  },
  renderExitIntentTriggerContent: function renderExitIntentTriggerContent(type, displayOnExitIntent, updateTriggers) {
    if (type === _DynoTypes.default.POP_OVER) {
      return _react.default.createElement("div", null, _react.default.createElement(_UICheckbox.default, {
        defaultChecked: displayOnExitIntent,
        onChange: function onChange(_ref2) {
          var checked = _ref2.target.checked;
          return updateTriggers({
            displayOnExitIntent: checked
          });
        }
      }, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('onExitIntent')
      }), this.renderRecommended(type === _DynoTypes.default.POP_OVER)));
    }

    return null;
  },
  renderTimedDelayedTriggerContent: function renderTimedDelayedTriggerContent(type, displayOnTimedDelay, updateTriggers) {
    var helpText = _react.default.createElement("span", null, this.renderRecommended(type === _DynoTypes.default.TOP), _react.default.createElement(_Small.default, {
      use: "help",
      className: "m-left-2"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: this.langKey('minSevenSeconds')
    })));

    return _react.default.createElement(_DynoElapsedTimeInput.default, {
      initialValue: displayOnTimedDelay / 1000,
      onChange: function onChange(value) {
        return updateTriggers({
          displayOnTimedDelay: value * 1000
        });
      },
      helpText: helpText
    });
  },
  render: function render() {
    var _this$props = this.props,
        type = _this$props.type,
        error = _this$props.error,
        displayOnScroll = _this$props.displayOnScroll,
        displayOnExitIntent = _this$props.displayOnExitIntent,
        displayOnTimedDelay = _this$props.displayOnTimedDelay,
        handleUpdateTriggers = _this$props.handleUpdateTriggers,
        validationMessage = _this$props.validationMessage;
    var scrollTriggerContent = this.renderScrollTriggerContent(type, displayOnScroll, handleUpdateTriggers);
    var exitIntentTriggerContent = this.renderExitIntentTriggerContent(type, displayOnExitIntent, handleUpdateTriggers);
    var timedDelayedTriggerContent = this.renderTimedDelayedTriggerContent(type, displayOnTimedDelay, handleUpdateTriggers);
    return _react.default.createElement(_UIFormControl.default, {
      className: "private-toggle-group",
      error: error,
      validationMessage: validationMessage
    }, _react.default.createElement(_SimpleWrapper.default, null, _react.default.createElement("div", {
      className: "dyno-triggers"
    }, scrollTriggerContent, exitIntentTriggerContent, timedDelayedTriggerContent)));
  }
});

exports.default = _default;
module.exports = exports.default;